import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-the-page-m12__form c-form-inner" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "p-form-group" }
const _hoisted_4 = { class: "p-form-group" }
const _hoisted_5 = { class: "p-form-button-group" }
const _hoisted_6 = { class: "p-form-button-group__vertical" }
const _hoisted_7 = { class: "p-form-button-group__vertical" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormLabel = _resolveComponent("FormLabel")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_ValidationErrorText = _resolveComponent("ValidationErrorText")!
  const _component_ValidationProvider = _resolveComponent("ValidationProvider")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ButtonMain = _resolveComponent("ButtonMain")!
  const _component_ValidationObserver = _resolveComponent("ValidationObserver")!
  const _component_TheTemplateM = _resolveComponent("TheTemplateM")!

  return (_openBlock(), _createBlock(_component_TheTemplateM, { class: "p-the-page-m12" }, {
    heading: _withCtx(() => _cache[2] || (_cache[2] = [
      _createTextVNode("秘密の質問の変更", -1)
    ])),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_ValidationObserver, { slim: "" }, {
          default: _withCtx((ObserverProps) => [
            _createElementVNode("form", {
              ref: "form",
              action: "/m01/m12_complete.html",
              method: "post",
              onSubmit: _withModifiers(($event: any) => (_ctx.submit(ObserverProps)), ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_FormLabel, {
                  for: "secretQuestion",
                  required: true
                }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode("秘密の質問", -1)
                  ])),
                  _: 1,
                  __: [3]
                }),
                _createVNode(_component_ValidationProvider, {
                  name: "秘密の質問",
                  rules: "required"
                }, {
                  default: _withCtx((ProviderProps) => [
                    _createVNode(_component_InputSelect, {
                      id: "secretQuestion",
                      modelValue: _ctx.secretQuestion,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.secretQuestion) = $event)),
                      name: "secretQuestion",
                      error: ProviderProps.errors[0],
                      options: _ctx.secretQuestionOptions
                    }, null, 8, ["modelValue", "error", "options"]),
                    _withDirectives(_createVNode(_component_ValidationErrorText, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(ProviderProps.errors[0]), 1)
                      ]),
                      _: 2
                    }, 1536), [
                      [_vShow, ProviderProps.errors[0]]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_FormLabel, {
                  for: "secretAnswer",
                  required: true
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode("秘密の質問の答え", -1)
                  ])),
                  _: 1,
                  __: [4]
                }),
                _createVNode(_component_ValidationProvider, {
                  name: "秘密の質問の答え",
                  rules: "required|max:100"
                }, {
                  default: _withCtx((ProviderProps) => [
                    _createVNode(_component_InputText, {
                      id: "secretAnswer",
                      modelValue: _ctx.secretAnswer,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.secretAnswer) = $event)),
                      type: "text",
                      name: "secretAnswer",
                      placeholder: "質問の答え",
                      error: ProviderProps.errors[0]
                    }, null, 8, ["modelValue", "error"]),
                    _withDirectives(_createVNode(_component_ValidationErrorText, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(ProviderProps.errors[0]), 1)
                      ]),
                      _: 2
                    }, 1536), [
                      [_vShow, ProviderProps.errors[0]]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_ButtonMain, {
                    type: "submit",
                    disabled: ObserverProps.invalid,
                    onClickButton: _ctx.submitAnswer
                  }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode("変更", -1)
                    ])),
                    _: 2,
                    __: [5]
                  }, 1032, ["disabled", "onClickButton"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_ButtonMain, {
                    tag: 'a',
                    href: "/my-page/",
                    kind: 'cancel'
                  }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode("キャンセル", -1)
                    ])),
                    _: 1,
                    __: [6]
                  })
                ])
              ])
            ], 40, _hoisted_2)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}